import { render } from "./ViewCandidate.vue?vue&type=template&id=0d82d0b7"
import script from "./ViewCandidate.vue?vue&type=script&lang=js"
export * from "./ViewCandidate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__